import axios from "./axiosInstance";
import { Globals } from "../global/Globals";

export const approveRejectRegistration = async (producerId, isApproved, comment) => {
    const params = `producerId=${producerId}&isApproved=${isApproved}&comments=${comment}`
    const apiResponse = await axios.put(Globals.ENDPOINT.SYS_ADMIN_APPROVE_REJECT_REG + params);
    return apiResponse;
}

export const getProducerByProducerID=async(producerId)=>{
    const apiResponse=await axios.get(Globals.ENDPOINT.GET_PRODUCER_DETAILS_BYID+producerId);
    return apiResponse;
}